import { Alert, Button, Modal, Table } from "antd";
import { useEffect, useState } from "react";

const ErrorModalTable = ({ result, onClose }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const arr = [];
    let i = 1;
    for (const item in result) {
      const that = result[item];
      if (that.length > 0) {
        arr.push({
          key: i,
          message: that.join(", "),
        });
      }
      i++;
    }
    setData(arr);
  }, [result]);

  const columns = [
    {
      title: <div style={{ textAlign: "center" }}>Excel Satır Numarası</div>,
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (val) => <div style={{ textAlign: "center" }}>{val}</div>,
    },
    {
      title: "Uyarı",
      dataIndex: "message",
      key: "message",
    },
  ];
  return (
    <Modal
      width={800}
      visible
      title={null}
      onCancel={onClose}
      footer={[
        <Button key="close" type="secondary" onClick={onClose}>
          Pencereyi Kapat
        </Button>,
      ]}
    >
      <Alert
        style={{ margin: "20px 0" }}
        showIcon
        type="warning"
        message="Yüklemeye çalıştığınız excelde eksik alanlar bulunmaktadır. Lütfen
        aşağındaki tabloda yer alan alanları düzelterek tekrar deneyiniz."
      />

      <Table
        columns={columns}
        dataSource={data}
        size="small"
        bordered
        pagination={false}
        scroll={{ x: "max-content", y: 500 }}
      />
    </Modal>
  );
};

export default ErrorModalTable;
